export default "__VITE_ASSET__mszksOJ9__"